import { get, post } from 'aws-amplify/api'

import { Auth } from './auth'
import { type GraphQLResult, graphql, graphqlOperation } from './graphql'
import { Storage } from './storage'

const parseRestResponse = async (
	operation: ReturnType<typeof get | typeof post>
) => {
	const { body } = await operation.response
	try {
		return await body.json()
	} catch {
		return body.text()
	}
}

const mapRestOptions = (options: any = {}) => {
	const { queryStringParameters, ...rest } = options
	return {
		...rest,
		queryParams: rest.queryParams ?? queryStringParameters,
	}
}

export const API = {
	graphql: (
		operation: { query: string; variables?: any },
		variables?: Record<string, unknown>
	) => {
		return graphql(operation.query, variables ?? operation.variables)
	},
	get: (apiName: string, path: string, options?: any) => {
		return parseRestResponse(
			get({
				apiName,
				path,
				options: mapRestOptions(options),
			})
		)
	},
	post: (apiName: string, path: string, options?: any) => {
		return parseRestResponse(
			post({
				apiName,
				path,
				options: mapRestOptions(options),
			})
		)
	},
}

export { Auth, graphqlOperation, Storage }
export type { GraphQLResult }
